import { SerializedConstructor } from 'node_modules/@langchain/core/dist/load/serializable';

import { convertManifestToMessages } from '@/Pages/Playground/components/manifest/serialized/prompts/ManifestChatPromptTemplate.utils';

import { getMessagesFromManifest } from '../../utils';
import { GetMessageDiffsArgs, StoredMessageDiffsRecord } from '../types';
import { CommitChatPromptDiff } from './CommitChatPromptManifest';
import { CommitPromptDiff } from './CommitPromptManifest';

export const WholePromptDiff = ({
  commitId,
  getMessageDiffs,
  previousCommit,
  currentCommit,
  isPreviousChat,
}: {
  commitId: string;
  getMessageDiffs: (args: GetMessageDiffsArgs) => StoredMessageDiffsRecord;
  previousCommit: SerializedConstructor;
  currentCommit: SerializedConstructor;
  isPreviousChat: boolean;
}) => {
  if (isPreviousChat) {
    const previousCommitMsgs = convertManifestToMessages(
      getMessagesFromManifest(previousCommit)
    );
    return (
      <>
        <CommitPromptDiff
          currentCommitMsg={getMessagesFromManifest(currentCommit)}
          previousCommitMsg={''}
        />
        <CommitChatPromptDiff
          commitId={commitId}
          getMessageDiffs={getMessageDiffs}
          currentCommitMsgs={[]}
          previousCommitMsgs={previousCommitMsgs}
          currentCommitSchema={undefined}
          previousCommitSchema={previousCommit.kwargs.schema_}
        />
      </>
    );
  } else {
    const currentCommitMsgs = convertManifestToMessages(
      getMessagesFromManifest(currentCommit)
    );
    return (
      <>
        <CommitChatPromptDiff
          commitId={commitId}
          getMessageDiffs={getMessageDiffs}
          currentCommitMsgs={currentCommitMsgs}
          previousCommitMsgs={[]}
          currentCommitSchema={currentCommit.kwargs.schema_}
          previousCommitSchema={undefined}
        />
        <CommitPromptDiff
          currentCommitMsg={''}
          previousCommitMsg={getMessagesFromManifest(previousCommit)}
        />
      </>
    );
  }
};
